<template>
  <div class="content_box">
    <div class="content_box_inner">
      <div class="headTitle">
        <img src="@/assets/imgs/icon/icon_company.png" alt />
        企业库
      </div>
      <div class="topBtnBox">
        <el-row style="width: 100%">
          <el-col :xs="24" :lg="8">
            <el-button type="primary" class="bg5584FF" @click="openSeach">
              高级查询选项&emsp;
              <i
                :class="[
                  'el-icon-caret-top',
                  { show: showSearch, close: !showSearch },
                ]"
              ></i>
            </el-button>
          </el-col>
          <el-col
            :xs="24"
            :lg="16"
            :style="screenWidth < 1200 ? 'display:none' : 'display:block'"
          >
            <div class="loadBtn" style="float: right">
              <el-button type="primary" class="bg5584FF" @click="leadingOut"
                >批量导出企业</el-button
              >
              <el-button
                type="primary"
                class="bg5584FF"
                style="margin-left: 10px"
                @click="openLoadWindow"
                >批量导入企业</el-button
              >
              <el-button type="primary" class="bg5584FF" @click="batchStop"
                >批量停用企业</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div>
      <transition name="hr">
        <hr v-show="!showSearch" />
      </transition>
      <!-- 搜索 -->
      <transition name="search">
        <div class="searchBox" v-show="showSearch">
          <el-form
            :inline="true"
            class="demo-form-inline half"
            label-position="right"
            ref="searchForm"
            label-width="124px"
            :model="searchObj"
          >
            <el-row style="width: 100%">
              <el-col :xs="12" :lg="6">
                <el-form-item label="所在区县">
                  <el-select v-model="searchObj.district" placeholder="请选择">
                    <el-option
                      v-for="item in seatList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :lg="6">
                <el-form-item label="所在园区">
                  <el-select v-model="searchObj.park" placeholder="请选择">
                    <el-option
                      v-for="item in parkList"
                      :key="item.id"
                      :label="item.label"
                      :value="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :lg="6">
                <el-form-item label="国民经济行业">
                  <el-select
                    v-model="searchObj.industryType"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in industryList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :lg="6">
                <el-form-item label="登记注册类型">
                  <el-select
                    v-model="searchObj.registerType"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in registerList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="width: 100%">
              <el-col :xs="12" :lg="6">
                <el-form-item label="是否规上">
                  <el-select
                    v-model="searchObj.aboveScale"
                    placeholder="请选择"
                  >
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :lg="6">
                <el-form-item label="是否上市">
                  <el-select v-model="searchObj.listed" placeholder="请选择">
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :lg="6">
                <el-form-item label="是否军工">
                  <el-select v-model="searchObj.military" placeholder="请选择">
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :lg="6">
                <el-form-item label="企业规模">
                  <el-select
                    v-model="searchObj.companySize"
                    placeholder="请选择"
                  >
                    <el-option label="大型" value="大型"></el-option>
                    <el-option label="中型" value="中型"></el-option>
                    <el-option label="小型" value="小型"></el-option>
                    <el-option label="微型" value="微型"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="width: 100%">
              <el-col :xs="12" :lg="6">
                <el-form-item label="企业类别">
                  <el-select
                    v-model="searchObj.companyCategory"
                    placeholder="请选择"
                  >
                    <el-option label="50户重点" value="50户重点"></el-option>
                    <el-option label="小巨人" value="小巨人"></el-option>
                    <el-option label="专精特新" value="专精特新"></el-option>
                    <el-option label="隐形冠军" value="隐形冠军"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :lg="6">
                <el-form-item label="企业性质">
                  <el-select
                    v-model="searchObj.companyNature"
                    placeholder="请选择"
                  >
                    <el-option label="国有" value="国有"></el-option>
                    <el-option label="民营" value="民营"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :lg="6">
                <el-form-item label="“565”产业">
                  <el-cascader
                    v-model="searchObj.company565"
                    :options="Company565List"
                    :props="deftProps"
                    placeholder="请选择"
                  ></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :lg="6">
                <el-form-item label="是否超10亿元">
                  <el-select
                    v-model="searchObj.oneBillion"
                    placeholder="请选择"
                  >
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="width: 100%">
              <el-col :xs="12" :lg="6">
                <el-form-item label="提质倍增">
                  <el-select
                    v-model="searchObj.multiplication"
                    placeholder="请选择"
                  >
                    <el-option label="市级" value="市级"></el-option>
                    <el-option label="区县级" value="区县级"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :lg="6">
                <el-form-item label="店小二服务">
                  <el-select
                    v-model="searchObj.xiaoerService"
                    placeholder="请选择"
                  >
                    <el-option label="是" value="是"></el-option>
                    <el-option label="否" value="否"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :lg="6">
                <el-form-item label="“三大改造”实施">
                  <el-select
                    v-model="searchObj.threeChanges"
                    placeholder="请选择"
                  >
                    <el-option
                      label="智能化改造"
                      value="智能化改造"
                    ></el-option>
                    <el-option
                      label="绿色化改造"
                      value="绿色化改造"
                    ></el-option>
                    <el-option label="技术改造" value="技术改造"></el-option>
                    <el-option label="未实施" value="未实施"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :lg="6">
                <el-form-item label="启用状态">
                  <el-select v-model="searchObj.status" placeholder="请选择">
                    <el-option label="启用" value="1"></el-option>
                    <el-option label="停用" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="width: 100%">
              <el-col :xs="12" :lg="6">
                <el-form-item label="企业名称">
                  <el-input
                    v-model.trim="searchObj.name"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :lg="6">
                <el-form-item label="联系手机">
                  <el-input
                    v-model.trim="searchObj.contactPhone"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :lg="6">
                <el-form-item label="联系人姓名">
                  <el-input
                    v-model.trim="searchObj.contactName"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :lg="6">
                <el-form-item label="法定代表人">
                  <el-input
                    v-model.trim="searchObj.representativePerson"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="width: 100%" align="center">
              <el-form-item
                style="width: 200px; margin: 0 auto 20px; display: block"
              >
                <el-button
                  type="primary"
                  class="bg5584FF formBotton"
                  @click="onSearch"
                  >查询</el-button
                >
                <el-button type="info" class="formBotton" @click="onReset"
                  >重置</el-button
                >
              </el-form-item>
            </el-row>
          </el-form>
        </div>
      </transition>
      <el-row style="background: #fff; padding: 0px 0 20px">
        <el-col
          :xs="24"
          :lg="12"
          :style="screenWidth > 1200 ? 'display:none' : 'display:block'"
          style="margin-bottom: 10px"
        >
          <div
            class="loadBtn"
            :style="screenWidth > 1200 ? 'float: right' : 'float: left'"
          >
            <el-button
              type="primary"
              class="bg5584FF"
              style="padding: 6px 6px"
              size="mini"
              @click="leadingOut"
              >批量导出企业</el-button
            >
            <el-button
              type="primary"
              class="bg5584FF"
              style="margin-left: 10px; padding: 6px 6px"
              size="mini"
              @click="openLoadWindow"
              >批量导入企业</el-button
            >
            <el-button
              type="primary"
              class="bg5584FF"
              style="padding: 6px 6px"
              size="mini"
              @click="batchStop"
              >批量停用企业</el-button
            >
          </div>
        </el-col>
        <el-col :xs="24" :lg="12">
          <el-button
            type="primary"
            size="small"
            class="bg5584FF"
            @click="addNew"
          >
            <i class="el-icon-plus"></i> 新增企业
          </el-button>
        </el-col>
      </el-row>

      <!-- 表格数据 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        :header-cell-style="{
          backgroundColor: '#DCDFE6',
          color: '#000',
        }"
        v-loading="loading"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          prop="name"
          label="企业名称"
          show-overflow-tooltip
          fixed
        >
          <template slot-scope="scope">
            <span class="detail" @click="handleDetail(scope.row)">{{
              scope.row.name
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="district"
          label="所在区县"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="park"
          label="所在园区"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="industryType"
          label="国民经济行业"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="registerType"
          label="登记注册类型"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="code"
          label="统一社会信用代码"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="status" label="状态" width="70" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 1">
              <img
                src="@/assets/imgs/icon/greenRound.png"
                alt
                style="vertical-align: middle; display: inline"
              />
              <span style="margin-left: 6px">启用</span>
            </div>
            <div v-else>
              <img
                src="@/assets/imgs/icon/redRound.png"
                alt
                style="vertical-align: middle; display: inline"
              />
              <span style="margin-left: 6px">停用</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="248" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              class="bg5584FF"
              type="primary"
              @click="editCompany(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              class="bg5584FF"
              type="primary"
              @click="reportDistribution(scope.row)"
              >报表分配</el-button
            >
            <el-button
              size="mini"
              class="green"
              type="primary"
              @click="useCompany(scope.row.id)"
              v-if="scope.row.status == 2"
              >启用</el-button
            >
            <el-button
              size="mini"
              class="red"
              type="primary"
              @click="openStopWindow(scope.row.id)"
              v-else
              >停用</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pageBox">
        <el-pagination
          class="pagePC"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          layout="total,  prev, pager, next"
          :total="total"
        >
        </el-pagination>
        <van-pagination
          class="pagePhone"
          v-model="currentPage"
          :total-items="total"
          :items-per-page="10"
          :show-page-size="3"
          @change="changePage"
          force-ellipses
        />
      </div>
      <!-- 新增企业 -->
      <el-dialog
        title="新增企业"
        :visible.sync="showAddWindow"
        :width="screenWidth < 1200 ? '94%' : '800px'"
        class="titleChange bodyScroll"
        :close-on-click-modal="false"
        @closed="addHandleClose"
      >
        <div class="lineTitle">
          <span>基本信息</span>
          <!-- <span class="number">12</span> -->
        </div>
        <el-form
          :inline="true"
          :model="addObj"
          class="demo-form-inline half"
          size="mini"
          label-width="135px"
          label-position="right"
          ref="addForm"
          :rules="rules"
          v-loading="addLoading"
        >
          <el-row>
            <el-col :xs="24" :lg="12">
              <el-form-item label="企业名称" prop="name">
                <el-input
                  v-model.trim="addObj.name"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="统一社会信用代码" prop="code">
                <el-input
                  v-model.trim="addObj.code"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="登记注册类型">
                <el-select
                  v-model="addObj.registerType"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in registerList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                  <el-option label="无" value="无"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="国民经济行业">
                <el-select
                  v-model="addObj.industryType"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in industryList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                  <el-option label="无" value="无"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="注册资金（万元）">
                <el-input
                  v-model.trim="addObj.registerMoney"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="注册时间">
                <el-date-picker
                  v-model="addObj.registerTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="法定代表人">
                <el-input
                  v-model.trim="addObj.representativePerson"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="邮政编码">
                <el-input
                  v-model.trim="addObj.postCode"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="所在工业园区">
                <el-select v-model="addObj.park" clearable placeholder="请选择">
                  <el-option label="不在园区内" value="不在园区内"></el-option>
                  <el-option
                    v-for="item in parkList"
                    :key="item.id"
                    :label="item.label"
                    :value="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="是否规上">
                <el-select
                  v-model="addObj.aboveScale"
                  clearable
                  placeholder="请选择"
                >
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="是否上市">
                <el-select
                  v-model="addObj.listed"
                  clearable
                  placeholder="请选择"
                >
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="是否军工">
                <el-select
                  v-model="addObj.military"
                  clearable
                  placeholder="请选择"
                >
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="企业规模">
                <el-select
                  v-model="addObj.companySize"
                  clearable
                  placeholder="请选择"
                >
                  <el-option label="大型" value="大型"></el-option>
                  <el-option label="中型" value="中型"></el-option>
                  <el-option label="小型" value="小型"></el-option>
                  <el-option label="微型" value="微型"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="企业类别">
                <el-select
                  v-model="addObj.companyCategory"
                  clearable
                  placeholder="请选择"
                >
                  <el-option label="50户重点" value="50户重点"></el-option>
                  <el-option label="小巨人" value="小巨人"></el-option>
                  <el-option label="专精特新" value="专精特新"></el-option>
                  <el-option label="隐形冠军" value="隐形冠军"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="企业性质">
                <el-select
                  v-model="addObj.companyNature"
                  clearable
                  placeholder="请选择"
                >
                  <el-option label="国有" value="国有"></el-option>
                  <el-option label="民营" value="民营"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="“565”产业">
                <el-cascader
                  v-model="addObj.company565"
                  :options="Company565List"
                  :props="deftProps"
                  clearable
                  placeholder="请选择"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="是否10亿元">
                <el-select
                  v-model="addObj.oneBillion"
                  clearable
                  placeholder="请选择"
                >
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="提质倍增">
                <el-select
                  v-model="addObj.multiplication"
                  clearable
                  placeholder="请选择"
                >
                  <el-option label="市级" value="市级"></el-option>
                  <el-option label="区县级" value="区县级"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="是否店小二服务">
                <el-select
                  v-model="addObj.xiaoerService"
                  clearable
                  placeholder="请选择"
                >
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="“三大改造”实施">
                <el-select
                  v-model="addObj.threeChanges"
                  clearable
                  multiple
                  placeholder="请选择"
                >
                  <el-option label="智能化改造" value="智能化改造"></el-option>
                  <el-option label="绿色化改造" value="绿色化改造"></el-option>
                  <el-option label="技术改造" value="技术改造"></el-option>
                  <el-option label="未实施" value="未实施"></el-option>
                  <el-option label="已实施" value="已实施"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item
                label="注册区县"
                class="selection_item"
                prop="district"
              >
                <el-select
                  class="city_input_box"
                  v-model="luoyangCity"
                  :placeholder="city_name"
                  disabled
                >
                  <el-option :label="city_name" :value="city_name"></el-option>
                </el-select>
                <el-select
                  class="city_input_box"
                  v-model="addObj.district"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in seatList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="注册地址">
                <el-input
                  v-model.trim="addObj.registerAddress"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="24">
              <el-form-item label="办公地址">
                <el-input
                  class="address_input_box"
                  v-model.trim="addObj.officeAddress"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="24">
              <el-form-item label="公司简介" prop="companyProfile">
                <el-input
                  class="address_input_box"
                  type="textarea"
                  v-model.trim="addObj.companyProfile"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- <hr style="width: 100%; margin: 30px 0" /> -->
          <div class="lineTitle" style="width: 100%">联系信息</div>
          <el-row>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系邮箱">
                <el-input
                  v-model.trim="addObj.companyEmail"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="法定代表人电话">
                <el-input
                  v-model.trim="addObj.representativePhone"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系人姓名">
                <el-input
                  v-model.trim="addObj.contactName"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系人职务">
                <el-input
                  v-model.trim="addObj.contactPosition"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系手机" prop="contactPhone">
                <el-input
                  v-model.trim="addObj.contactPhone"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系座机">
                <el-input
                  v-model.trim="addObj.contactLandlinePhone"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item style="width: 100%; text-align: center">
            <div class="btnBox">
              <el-button
                type="primary"
                size="mini"
                class="bg5584FF"
                @click="sureAdd('addForm')"
                >确定</el-button
              >
              <el-button
                type="normal"
                size="mini"
                @click="showAddWindow = false"
                >取消</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 查看详情 -->
      <el-dialog
        title="企业详情"
        :visible.sync="showDetailWindow"
        :width="screenWidth < 1200 ? '94%' : '800px'"
        class="titleChange bodyScroll"
        :close-on-click-modal="false"
      >
        <div class="lineTitle">
          <span>基本信息</span>
        </div>
        <el-form
          :inline="true"
          :model="editObj"
          class="demo-form-inline half"
          size="mini"
          label-width="135px"
          label-position="right"
          ref="editForm"
        >
          <el-row>
            <el-col :xs="24" :lg="12">
              <el-form-item label="企业名称" prop="name">
                <el-input v-model.trim="editObj.name" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="统一社会信用代码">
                <el-input v-model.trim="editObj.code" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="登记注册类型">
                <el-input
                  v-model.trim="editObj.registerType"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="国民经济行业">
                <el-input
                  v-model.trim="editObj.industryType"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="注册资金（万元）">
                <el-input
                  v-model.trim="editObj.registerMoney"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="注册时间">
                <el-input v-model="editObj.registerTime" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="法定代表人">
                <el-input
                  v-model.trim="editObj.representativePerson"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="邮政编码">
                <el-input v-model.trim="editObj.postCode" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="所在工业园区">
                <el-input v-model.trim="editObj.park" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="是否规上">
                <el-input v-model.trim="editObj.aboveScale" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="是否上市">
                <el-input v-model.trim="editObj.listed" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="是否军工">
                <el-input v-model.trim="editObj.military" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="企业规模">
                <el-input
                  v-model.trim="editObj.companySize"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="企业类别">
                <el-input
                  v-model.trim="editObj.companyCategory"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="企业性质">
                <el-input
                  v-model.trim="editObj.companyNature"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="“565”产业">
                <el-cascader
                  v-model="editObj.company565"
                  :options="Company565List"
                  :props="deftProps"
                  disabled
                  placeholder
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="是否10亿元">
                <el-input v-model.trim="editObj.oneBillion" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="提质倍增">
                <el-input
                  v-model.trim="editObj.multiplication"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="是否店小二服务">
                <el-input
                  v-model.trim="editObj.xiaoerService"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="“三大改造”实施">
                <el-select v-model="editObj.threeChanges" multiple disabled>
                  <el-option label="智能化改造" value="智能化改造"></el-option>
                  <el-option label="绿色化改造" value="绿色化改造"></el-option>
                  <el-option label="技术改造" value="技术改造"></el-option>
                  <el-option label="未实施" value="未实施"></el-option>
                  <el-option label="已实施" value="已实施"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="注册区县" class="selection_item">
                <el-input
                  class="city_input_box_1"
                  v-model.trim="luoyangCity"
                  disabled
                  :placeholder="city_name"
                ></el-input>
                <el-input
                  class="city_input_box_1"
                  v-model.trim="editObj.district"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="注册地址">
                <el-input
                  v-model.trim="editObj.registerAddress"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="24">
              <el-form-item label="办公地址">
                <el-input
                  class="address_input_box"
                  v-model.trim="editObj.officeAddress"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="24">
              <el-form-item label="公司简介">
                <el-input
                  class="address_input_box"
                  type="textarea"
                  v-model="editObj.companyProfile"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <div class="lineTitle" style="width: 100%">联系信息</div>
          <el-row>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系邮箱">
                <el-input
                  v-model.trim="editObj.companyEmail"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="法定代表人电话">
                <el-input
                  v-model.trim="editObj.representativePhone"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系人姓名">
                <el-input
                  v-model.trim="editObj.contactName"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系人职务">
                <el-input
                  v-model.trim="editObj.contactPosition"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系手机" prop="contactPhone">
                <el-input
                  v-model.trim="editObj.contactPhone"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系座机">
                <el-input
                  v-model.trim="editObj.contactLandlinePhone"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12"></el-col>
          </el-row>
        </el-form>
      </el-dialog>
      <!-- 编辑企业 -->
      <el-dialog
        title="编辑企业"
        :visible.sync="showEditWindow"
        :width="screenWidth < 1200 ? '94%' : '800px'"
        class="titleChange bodyScroll"
        :close-on-click-modal="false"
        @closed="editHandleClose"
      >
        <div class="lineTitle">
          <span>基本信息</span>
        </div>
        <el-form
          :inline="true"
          :model="editObj"
          class="demo-form-inline half"
          size="mini"
          label-width="135px"
          label-position="right"
          ref="editForm"
          :rules="rules"
          v-loading="editLoading"
        >
          <el-row>
            <el-col :xs="24" :lg="12">
              <el-form-item label="企业名称" prop="name">
                <el-input
                  v-model.trim="editObj.name"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="统一社会信用代码">
                <el-input
                  v-model.trim="editObj.code"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="登记注册类型">
                <el-select
                  v-model="editObj.registerType"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in registerList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                  <el-option label="无" value="无"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="国民经济行业">
                <el-select
                  v-model="editObj.industryType"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in industryList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                  <el-option label="无" value="无"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="注册资金（万元）">
                <el-input
                  v-model.trim="editObj.registerMoney"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="注册时间">
                <el-date-picker
                  v-model="editObj.registerTime"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="法定代表人">
                <el-input
                  v-model.trim="editObj.representativePerson"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="邮政编码">
                <el-input
                  v-model.trim="editObj.postCode"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="所在工业园区">
                <el-select
                  v-model="editObj.park"
                  clearable
                  placeholder="请选择"
                >
                  <el-option label="不在园区内" value="不在园区内"></el-option>
                  <el-option
                    v-for="item in parkList"
                    :key="item.id"
                    :label="item.label"
                    :value="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="是否规上">
                <el-select
                  v-model="editObj.aboveScale"
                  clearable
                  placeholder="请选择"
                >
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="是否上市">
                <el-select
                  v-model="editObj.listed"
                  clearable
                  placeholder="请选择"
                >
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="是否军工">
                <el-select
                  v-model="editObj.military"
                  clearable
                  placeholder="请选择"
                >
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="企业规模">
                <el-select
                  v-model="editObj.companySize"
                  clearable
                  placeholder="请选择"
                >
                  <el-option label="大型" value="大型"></el-option>
                  <el-option label="中型" value="中型"></el-option>
                  <el-option label="小型" value="小型"></el-option>
                  <el-option label="微型" value="微型"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="企业类别">
                <el-select
                  v-model="editObj.companyCategory"
                  clearable
                  placeholder="请选择"
                >
                  <el-option label="50户重点" value="50户重点"></el-option>
                  <el-option label="小巨人" value="小巨人"></el-option>
                  <el-option label="专精特新" value="专精特新"></el-option>
                  <el-option label="隐形冠军" value="隐形冠军"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="企业性质">
                <el-select
                  v-model="editObj.companyNature"
                  clearable
                  placeholder="请选择"
                >
                  <el-option label="国有" value="国有"></el-option>
                  <el-option label="民营" value="民营"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="“565”产业">
                <el-cascader
                  v-model="editObj.company565"
                  :options="Company565List"
                  :props="deftProps"
                  clearable
                  placeholder="请选择"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="是否10亿元">
                <el-select
                  v-model="editObj.oneBillion"
                  clearable
                  placeholder="请选择"
                >
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="提质倍增">
                <el-select
                  v-model="editObj.multiplication"
                  clearable
                  placeholder="请选择"
                >
                  <el-option label="市级" value="市级"></el-option>
                  <el-option label="区县级" value="区县级"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="是否店小二服务">
                <el-select
                  v-model="editObj.xiaoerService"
                  clearable
                  placeholder="请选择"
                >
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="“三大改造”实施">
                <el-select
                  v-model="editObj.threeChanges"
                  multiple
                  placeholder="请选择"
                >
                  <el-option label="智能化改造" value="智能化改造"></el-option>
                  <el-option label="绿色化改造" value="绿色化改造"></el-option>
                  <el-option label="技术改造" value="技术改造"></el-option>
                  <el-option label="未实施" value="未实施"></el-option>
                  <el-option label="已实施" value="已实施"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="注册区县" class="selection_item">
                <el-select
                  class="city_input_box"
                  v-model="luoyangCity"
                  :placeholder="city_name"
                  disabled
                >
                  <el-option :label="city_name" :value="city_name"></el-option>
                </el-select>
                <el-select
                  class="city_input_box"
                  v-model="editObj.district"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in seatList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="注册地址">
                <el-input
                  v-model.trim="editObj.registerAddress"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="24">
              <el-form-item label="办公地址">
                <el-input
                  class="address_input_box"
                  v-model.trim="editObj.officeAddress"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="24">
              <el-form-item label="公司简介" prop="companyProfile">
                <el-input
                  class="address_input_box"
                  type="textarea"
                  v-model="editObj.companyProfile"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <div class="lineTitle" style="width: 100%">联系信息</div>
          <el-row>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系邮箱">
                <el-input
                  v-model.trim="editObj.companyEmail"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="法定代表人电话">
                <el-input
                  v-model.trim="editObj.representativePhone"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系人姓名">
                <el-input
                  v-model.trim="editObj.contactName"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系人职务">
                <el-input
                  v-model.trim="editObj.contactPosition"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系手机" prop="contactPhone">
                <el-input
                  v-model.trim="editObj.contactPhone"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="联系座机">
                <el-input
                  v-model.trim="editObj.contactLandlinePhone"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12"></el-col>
          </el-row>

          <el-form-item style="width: 100%; text-align: center">
            <div class="btnBox">
              <el-button
                type="primary"
                size="mini"
                class="bg5584FF"
                @click="sureEdit('editForm')"
                >确定</el-button
              >
              <el-button
                type="normal"
                size="mini"
                @click="showEditWindow = false"
                >取消</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 报表分配 -->
      <el-dialog
        title="报表分配"
        :visible.sync="allotDialogVisible"
        :width="screenWidth < 1200 ? '94%' : '60%'"
        class="titleChange"
        @closed="allothandleClose"
        :close-on-click-modal="false"
      >
        <!-- <div class="search">
        <el-input v-model.trim="searchText" suffix-icon="el-icon-search" placeholder="请输入内容"></el-input>
      </div>-->
        <div v-loading="reportLoading">
          <el-table
            :data="reportTableData"
            ref="multipleTable"
            style="width: 100%"
            :header-cell-style="{
              backgroundColor: 'rgb(90, 161, 226)',
              color: '#fff',
            }"
            height="420"
            @selection-change="allotHandleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="50"
              fixed
            ></el-table-column>
            <el-table-column
              align="center"
              prop="reportCode"
              label="报表编号"
              fixed
            ></el-table-column>
            <el-table-column
              fixed
              align="center"
              prop="reportName"
              label="报表名称"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="reportType"
              label="报表类型"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="reportReview"
              label="审核部门"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              align="center"
              prop="reportStatus"
              label="报表属性"
            >
              <template slot-scope="scope">{{
                scope.row.reportReminder == 1 ? "企业" : "园区"
              }}</template>
            </el-table-column>
            <!-- <el-table-column align="center" prop="code" label="填报企业类型"></el-table-column> -->
            <el-table-column align="center" label="状态">
              <template slot-scope="scope">{{
                scope.row.reportStatus == 0 ? "启用" : "禁用"
              }}</template>
            </el-table-column>
          </el-table>
          <div class="btnBox">
            <el-button
              type="primary"
              size="mini"
              class="bg5584FF"
              @click="onSaveAllot"
              >保存</el-button
            >
            <el-button
              type="normal"
              size="mini"
              @click="allotDialogVisible = false"
              >取消</el-button
            >
          </div>
        </div>
      </el-dialog>
      <!-- 批量导入弹框 -->
      <el-dialog
        title="批量导入企业"
        :visible.sync="showLoadWindow"
        class="titleChange"
        :width="screenWidth < 1200 ? '94%' : '36%'"
        :close-on-click-modal="false"
      >
        <el-form
          label-width="150px"
          :model="loadObj"
          :rules="loadRule"
          v-loading="showLoadWindowloading"
        >
          <el-form-item label="是否覆盖历史数据：">
            <el-radio-group v-model="loadObj.isReset">
              <el-radio :label="0">是</el-radio>
              <el-radio :label="1">否</el-radio>
            </el-radio-group>
            <p style="height: 20px; margin: 0; line-height: 22px">
              （如果不历史覆盖，将只导入最新数据）
            </p>
          </el-form-item>
          <el-form-item label="请选择Excel文件：">
            <input
              type="file"
              @change="selectFile($event)"
              accept="application/vnd.ms-excel"
              single
              id="loadiFlieInput"
              style="display: none"
            />
            <el-button
              type="primary"
              size="mini"
              class="bg5584FF"
              @click="triggerSelect"
            >
              <img
                style="display: inline-block"
                src="@/assets/imgs/icon/icon_selectIcon.png"
              />&emsp;选择文件
            </el-button>
            <a
              :href="`${fileBaseUrl}/business/file/download/7fdb8a07090f488d99c34ecaf4d5a03a`"
              :class="screenWidth < 1200 ? '' : 'mL20'"
            >
              <el-button type="primary" class="bg5584FF" size="mini">
                <img
                  style="display: inline-block"
                  src="@/assets/imgs/icon/icon_loadIcon.png"
                />&emsp;下载企业导入模板
              </el-button>
            </a>
          </el-form-item>
          <el-form-item label>
            <div class="fileName">{{ upFile }}</div>
            <div>（导入的文件必须为EXcel2003格式！）</div>
          </el-form-item>
          <div class="btnBox MT40">
            <el-button
              type="primary"
              size="mini"
              class="bg5584FF"
              @click="sureLoad"
              >导入</el-button
            >
            <el-button type="normal" size="mini" @click="showLoadWindow = false"
              >取消</el-button
            >
          </div>
        </el-form>
      </el-dialog>
      <!-- 停用弹框 -->
      <el-dialog
        title="停用"
        :visible.sync="showStopWindow"
        class="delete"
        :close-on-click-modal="false"
      >
        <p>是否确定停用企业？</p>
        <div class="btnBox MT40">
          <el-button
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="stopCompany"
            >确定</el-button
          >
          <el-button type="normal" size="mini" @click="showStopWindow = false"
            >取消</el-button
          >
        </div>
      </el-dialog>
      <!-- 批量停用弹框 -->
      <el-dialog
        title="停用"
        :visible.sync="showBatchStopWindow"
        class="delete"
        :close-on-click-modal="false"
      >
        <p>是否确定停用选中企业？</p>
        <div class="btnBox MT40">
          <el-button
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="sureBatchStop"
            >确定</el-button
          >
          <el-button
            type="normal"
            size="mini"
            @click="showBatchStopWindow = false"
            >取消</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { Message } from "element-ui";
import { mapGetters } from "vuex";
export default {
  data() {
    // 手机号验证
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
      if (!value) {
        callback();
        // return callback(new Error("电话号码不能为空")); 必填验证  此处非必填
      }
      setTimeout(() => {
        if (!Number.isInteger(+value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (phoneReg.test(value)) {
            callback();
          } else {
            callback(new Error("电话号码格式不正确"));
          }
        }
      }, 100);
    };
    var onlyCode = (rule, value, callback) => {
      if (!value) {
        // callback();
        return callback(new Error("请输入统一社会信用代码"));
      } else {
        this.$axios
          .get(`/business/company/selectByCode/${value}`)
          .then((res) => {
            if (res.data >= 1) {
              callback(new Error("统一社会信用代码已存在"));
            } else if (res.data == 0) {
              callback();
            }
          });
      }
    };
    var checkLength = (rule, value, callback) => {
      if (value.length > 1000) {
        callback(
          new Error("输入长度限制为1000字符，当前输入长度" + value.length)
        );
      } else {
        callback();
      }
    };
    return {
      screenWidth: document.body.clientWidth, // 屏幕宽
      screeHeight: document.body.clientHeight, // 屏幕高
      showSearch: false, //查询展开
      showAddWindow: false, //新增企业
      showEditWindow: false, //编辑企业
      allotDialogVisible: false, //报表分配
      showLoadWindow: false, //批量导入企业
      showBatchStopWindow: false,
      showDetailWindow: false,
      showStopWindow: false,

      loading: false,
      addLoading: false,
      editLoading: false,
      reportLoading: false,
      showLoadWindowloading: false,
      fileBaseUrl: this.$GLOBAl.fileBaseUrl,
      parkList: [],
      industryList: [],
      registerList: [],
      Company565List: [],
      ids: [],
      reportReview: [],
      reportIds: [],
      currentPage: 1,
      allotReport: {},
      total: 0,
      pageNum: 1,
      companyId: "",

      upFile: "未选择任何文件",
      searchText: "", //查找文本
      luoyangCity: "",
      searchObj: {},
      tableData: [],
      reportTableData: [],
      addObj: {
        name: "", //企业名称
        code: "", //统一社会信用代码
        registerType: "",
        industryType: "",
        registerMoney: "",
        registerTime: "",
        representativePerson: "",
        postCode: "",
        park: "",
        aboveScale: "",
        listed: "",
        military: "",
        companySize: "",
        companyCategory: "",
        companyNature: "",
        company565: "",
        oneBillion: "",
        multiplication: "",
        xiaoerService: "",
        threeChanges: [],
        district: "",
        registerAddress: "",
        officeAddress: "",
        companyProfile: "",
        companyEmail: "",
        representativePhone: "",
        contactName: "",
        contactPosition: "",
        contactPhone: "",
        contactLandlinePhone: "",
      },
      editObj: {},
      deftProps: {
        expandTrigger: "hover",
        label: "name",
        value: "name",
      },
      loadObj: {
        isReset: 0,
        filePath: "",
      },
      rules: {
        name: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
        code: [{ required: true, validator: onlyCode, trigger: "blur" }],
        contactPhone: [
          { required: false, validator: checkPhone, trigger: "blur" },
        ],
        district: [
          { required: true, message: "请选择注册区县", trigger: "change" },
        ],
        registerType: [
          {
            required: true,
            message: "请选择登记注册类型，若没有请选择无",
            trigger: "change",
          },
        ],
        industryType: [
          {
            required: true,
            message: "请选择国民经济行业，若没有请选择无",
            trigger: "change",
          },
        ],
        companyProfile: [
          { validator: checkLength, trigger: "change" },
          // { min: 0, max: 20, message: "最多只能输入20个字符", trigger: "blur" }
        ],
      },
      loadRule: {},
      city_name: "",
    };
  },
  created() {
    this.getCompanyList({ pageNum: 1, pageSize: 10 });
    this.getSelectList();
    this.getReportTabelData();
  },
  mounted() {
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
    if (this.seatList1.length) {
      this.city_name = this.seatList1[0];
      console.log(this.city_name);
    }
  },
  computed: {
    ...mapGetters({
      seatList: "getAreaLists",
      seatList1: "getAreaListArr",
    }),
  },
  methods: {
    changePage() {
      this.pageNum = this.currentPage;
      this.getCompanyList(
        { pageNum: this.currentPage, pageSize: 10 },
        this.searchObj
      );
    },
    //批量导出企业
    leadingOut() {
      var that = this;
      let pms = Object.assign(that.searchObj);
      console.log(that.searchObj);
      console.log(pms);
      console.log(that.searchObj.length);
      var pmsStrArr = [];
      for (var i in pms) {
        pmsStrArr[pmsStrArr.length] = `${i}=${pms[i]}`;
      }
      console.log(pmsStrArr);
      var pmsStr = "";
      if (pmsStrArr.length == 0) {
        pmsStr = "/api/business/company/downloadCompanyExcel";
      } else {
        console.log(pmsStrArr.join("&"));
        pmsStr = `/api/business/company/downloadCompanyExcel?${pmsStrArr.join(
          "&"
        )}`;
        console.log(pmsStr);
      }
      function nullf(a) {
        if (a) {
          return a;
        } else {
          return "";
        }
      }

      window.open(`${window.location.origin}${pmsStr}`);
    },
    getCompanyList(pageObj, searchObj) {
      this.loading = true;
      let pms = Object.assign(pageObj, searchObj);
      this.$axios
        .get("/business/company/searchCompanyPageList", { params: pms })
        .then((res) => {
          this.tableData = res.data;
          this.total = res.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getReportTabelData() {
      this.$axios
        .get("/business/company/selectReport")
        .then((res) => {
          this.reportTableData = res.data;
          this.reportReview = res.data.reportReview;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getSelectList() {
      //获取下拉列表
      // 园区列表
      this.$axios.get("/business/park/selectParkNames").then((res) => {
        this.parkList = res.data;
      });
      // 国民经济行业列表
      this.$axios
        .get("/business/dm/hy/tree", {
          params: {
            parent_code: -1,
            is_select: 0,
          },
        })
        .then((res) => {
          this.industryList = res.data;
        });
      // 登记注册类型
      this.$axios.get("/business/company/selectRegisterType").then((res) => {
        this.registerList = res.data;
      });
      //565列表
      this.$axios.get("/business/company/selectCompany565List").then((res) => {
        this.Company565List = res.data;
      });
      //获取报表
    },
    openSeach() {
      //打开搜索框
      this.showSearch = !this.showSearch;
    },
    onSearch() {
      //查询
      this.searchObj.company565
        ? (this.searchObj.company565 = this.searchObj.company565[1])
        : "";
      this.getCompanyList({ pageNum: 1, pageSize: 10 }, this.searchObj);
    },
    onReset() {
      //重置
      this.searchObj = {};
      this.getCompanyList({ pageNum: 1, pageSize: 10 });
    },
    handleDetail(row) {
      this.$axios
        .get(`/business/company/selectByPrimarykey/${row.id}`)
        .then((res) => {
          this.editObj = res.data;
          this.showDetailWindow = true;
        });
    },
    openLoadWindow() {
      this.showLoadWindow = true;
      //批量导入企业
    },
    selectFile(e) {
      // let _this = this;
      // console.log(e);
      let file = e.target.files[0];
      let formData = new FormData();
      // console.log("选中的文件", file);
      let fileName = file.name.substr(file.name.lastIndexOf(".") + 1);
      // console.log(fileName);
      if (fileName !== "xls") {
        Message.error("请上传Excel2003格式文件");
        document.getElementById("loadiFlieInput").value = "";
        return;
      }
      this.upFile = file.name;
      formData.append("file", file);
      this.loadObj.filePath = formData;
      // console.log("上传参数", this.loadObj);
    },
    triggerSelect() {
      document.getElementById("loadiFlieInput").click();
    },
    //下载模板
    downLoadExl() {
      this.$axios
        .get("/business/company/download")
        .then((res) => {
          // console.log("下载模板结果", res);
          // window.open(res.data);
        })
        .catch((res) => {
          console.log("下载模板结果失败信息", res);
        });
    },
    //导入
    sureLoad() {
      if (!this.loadObj.filePath) {
        Message.error("请选择文件");
        return;
      }
      this.showLoadWindowloading = true;
      this.$axios
        // .post(
        //   `/business/company/importCompany/${this.loadObj.isReset}`,
        //   this.loadObj.filePath
        // )
        .post(
          `/business/company/importCompanyList?isReset=${this.loadObj.isReset}`,
          // isReset: this.loadObj.isReset,
          this.loadObj.filePath
        )
        .then((res) => {
          // console.log("导入结果", res);
          Message.success("导入成功");
          this.getCompanyList({ pageNum: 1, pageSize: 10 }, this.searchObj);
          this.showLoadWindowloading = false;
          this.loadObj.filePath = "";
          this.loadObj.isReset = 0;
          this.upFile = "";
          document.getElementById("loadiFlieInput").value = "";
          this.showLoadWindow = false;
        })
        .catch((res) => {
          this.showLoadWindowloading = false;
          console.log("导入结果失败信息", res);
        });
    },
    batchStop() {
      //批量停用企业
      this.showBatchStopWindow = true;
    },
    sureBatchStop() {
      //批量停用企业
      if (this.ids.length == 0) {
        Message.error("请勾选需要停用企业");
        return;
      }
      this.$axios
        .put(
          "/business/company/deleteCompanyByIds?status=2",
          JSON.stringify(this.ids)
        )
        .then((res) => {
          // console.log(res);
          Message.success("已停用");
          this.showBatchStopWindow = false;
          this.getCompanyList({ pageNum: 1, pageSize: 10 }, this.searchObj);
        });
    },
    addNew() {
      //新增企业
      this.showAddWindow = true;
    },
    sureAdd(formName) {
      //新增企业表单提交
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addLoading = true;
          this.addObj.threeChanges = JSON.stringify(this.addObj.threeChanges);
          this.addObj.company565
            ? (this.addObj.company565 = this.addObj.company565[1])
            : "";
          this.$axios
            .post("/business/company/insert", this.addObj)
            .then((res) => {
              Message.success("新增成功");
              this.addLoading = false;
              this.showAddWindow = false;
              this.getCompanyList({ pageNum: 1, pageSize: 10 }, this.searchObj);
              for (const key in this.addObj) {
                if (key == "threeChanges") {
                  this.addObj[key] = [];
                } else {
                  this.addObj[key] = "";
                }
              }
              console.log(this.addObj);
            })
            .catch(() => {
              this.addLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    editCompany(row) {
      this.showEditWindow = true;
      //企业修改
      this.$axios
        .get(`/business/company/selectByPrimarykey/${row.id}`)
        .then((res) => {
          this.editObj = res.data;
        });
    },
    sureEdit(formName) {
      //  确认修改
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editLoading = true;
          this.editObj.threeChanges = JSON.stringify(this.editObj.threeChanges);
          if (
            this.editObj.company565 != "" &&
            typeof this.editObj.company565 != "string"
          ) {
            this.editObj.company565 = this.editObj.company565[1];
          }
          this.$axios
            .put("/business/company/update", this.editObj)
            .then((res) => {
              Message.success("已修改");
              this.editLoading = false;
              this.showEditWindow = false;
              for (const key in this.editObj) {
                this.editObj[key] = "";
              }
              this.getCompanyList({ pageNum: 1, pageSize: 10 }, this.searchObj);
            })
            .catch(() => {
              this.editLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    reportDistribution(row) {
      //报表分配
      this.allotDialogVisible = true;
      this.companyId = row.id;
      this.$axios
        .get(`/business/company/companyReports/${row.id}`)
        .then((res) => {
          this.reportTableData.map((row) => {
            if (res.data.includes(row.id)) {
              this.$refs.multipleTable.toggleRowSelection(row, true);
            }
          });
        });
    },
    handleSelectionChange(val) {
      this.ids = val.map((res) => res.id);
      // console.log(this.ids);
    },
    allotHandleSelectionChange(selection) {
      //选择分配的数据
      this.reportIds = [];
      selection.forEach((item) => {
        this.reportIds.push(item.id);
      });
    },
    onSaveAllot() {
      // 报表分配保存
      this.reportLoading = true;
      // console.log(this.reportLoading);
      this.allotReport.reportIds = this.reportIds;
      this.allotReport.companyId = this.companyId;
      // console.log(this.allotReport);
      this.$axios
        .post("/business/company/chooseReport", this.allotReport)
        .then(() => {
          Message.success("已分配");
          this.reportLoading = false;
          this.allotDialogVisible = false;
          this.allotReport = {};
        })
        .catch(() => {
          this.reportLoading = false;
        });
    },
    useCompany(id) {
      //启用企业
      this.$axios
        .put(`/business/company/deleteCompanyById/${id}/1`)
        .then((res) => {
          Message.success("已启用");
          this.getCompanyList(
            { pageNum: this.pageNum, pageSize: 10 },
            this.searchObj
          );
        });
    },
    openStopWindow(id) {
      this.companyId = id;
      this.showStopWindow = true;
    },
    stopCompany(id) {
      // 停用企业
      // this.companyId = id;
      // this.showStopWindow = true;
      this.$axios
        .put(`/business/company/deleteCompanyById/${this.companyId}/2`)
        .then((res) => {
          Message.success("已停用");
          this.showStopWindow = false;
          this.getCompanyList(
            { pageNum: this.pageNum, pageSize: 10 },
            this.searchObj
          );
        });
    },
    addHandleClose() {
      this.$refs.addForm.resetFields();
      for (const key in this.addObj) {
        if (key == "threeChanges") {
          this.addObj[key] = [];
        } else {
          this.addObj[key] = "";
        }
      }
    },
    editHandleClose() {
      this.$refs.editForm.resetFields();
      for (const key in this.editObj) {
        this.editObj[key] = "";
      }
    },
    allothandleClose() {
      this.reportTableData.map((row) => {
        this.$refs.multipleTable.toggleRowSelection(row, false);
      });
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getCompanyList({ pageNum: val, pageSize: 10 }, this.searchObj);
    },
  },
};
</script>

<style lang="less" scoped>
.topBtnBox {
  display: flex;
  justify-content: space-between;

  i.show {
    animation: showRotate 0.5s forwards;
  }

  i.close {
    animation: closeRotate 0.5s forwards;
  }
}

@keyframes showRotate {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(180deg);
  }
}

@keyframes closeRotate {
  from {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(0);
  }
}

hr {
  border-color: rgba(155, 155, 155, 0.2);
  margin: 30px 0 20px;
}

.searchBox {
  overflow-y: none;
  height: auto;
  background-color: rgba(173, 173, 173, 0.02);
  border-radius: 2px;
  margin-bottom: 20px;
  // border: 1px solid rgba(114, 114, 114, 0.15);
  border-bottom: 1px solid #e4e7ed;

  .el-form {
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    div:nth-last-child(1) {
      box-sizing: border-box;
    }

    // .el-form-item {
    //   width: 24%;
    // }

    .item {
      width: 37%;
      display: flex;

      .el-form-item.halfOne {
        width: 55%;
        display: flex;
      }

      .el-form-item.halfTwo {
        width: 45%;
        display: flex;
      }
    }
  }
}

.search-leave-active,
.search-enter-active {
  transition: all 0.8s ease;
}

.search-leave-active,
.search-enter {
  height: 0px !important;
}

.search-leave,
.search-enter-active {
  height: 420px;
}

.hr-enter-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
  transition-delay: 0.2s;
}

.hr-leave-active {
  transition: all 0s cubic-bezier(1, 0.5, 0.8, 1);
}

.hr-enter,
.hr-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.search {
  width: 40%;
  margin-bottom: 15px;
}

.detail {
  width: 100%;
  height: 100%;
  cursor: pointer;
  color: #5584ff;
}

.fileName {
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  text-indent: 1em;
  font-weight: bolder;
}

.threeChanges {
  border: 1px solid;
  border-color: #e4e7ed;
  background-color: #f5f7fa;
  color: #c0c4cc;
  box-sizing: border-box;
  line-height: 28px;
  padding: 0 15px;
  font-size: 12px;

  span {
    height: 20px;
    display: inline-block;
    box-sizing: border-box;
    padding: 2px 4px;
    border: 1px solid #e9e9eb;
    border-radius: 3px;
    background-color: #f4f4f5;
  }
}
.content_box {
  padding: 20px 30px 30px;
}

.content_box_inner {
  padding: 10px 20px 20px;
  box-shadow: 0px 0px 50px #ccc;
}
.pagePhone {
  display: none;
}

@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
  .content_box_inner {
    padding: 10px 10px 20px;
  }
  .pagePC {
    display: none;
  }
  .pagePhone {
    display: flex;
  }
}
.topBtnBox i.show {
  display: inline-block !important;
}
</style>